import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Logger } from '../../../model/logger.model';
import { LoggingService } from '../../../service/logging.service';
import { ResellerStatementService } from '../../../../app/service/reseller-statement.service';
import { AuthNoticeService } from '../../../core/auth';
import { CampaignService } from '../../../core/services/campaign.service';
import { DelinquencyQuery } from '../../../persistence/dto/delinquency-query.model';
import { saveAs } from "file-saver";
import { AsyncJobService } from '../../../service/async-job.service';
import { MimeType } from '../../../model/mime-type.enum';
import { TruncatedExponentialBackoff } from '../../../support/truncated-exponential-backoff.model';

@Component({
  selector: 'kt-dialog-debt-report',
  templateUrl: './dialog-debt-report.component.html',
  styleUrls: ['./dialog-debt-report.component.scss']
})
export class DialogDebtReportComponent implements OnInit {

  detailForm: FormGroup;
  error: boolean = false;
  isLoadingResults = false;
  campaigns;
  filter = {
	  zone: undefined,
	  campaignStartId: undefined,
	  campaignEndId: undefined
  };

  private logger: Logger = this.loggingService.getLogger("dialog-debt-report.component");

  constructor(
	private cdr: ChangeDetectorRef,
	public dialogRef: MatDialogRef<DialogDebtReportComponent>,
	@Inject(MAT_DIALOG_DATA) public data: any,
	private fb: FormBuilder,
	private asyncJobService: AsyncJobService,
	private authNoticeService: AuthNoticeService,
	private campaignService: CampaignService,
	private loggingService: LoggingService,
	private resellerStamentService: ResellerStatementService) {}

  ngOnInit() {
	this.authNoticeService.setNotice(null);
	this.loadCampaigns();
	this.initForms();
  }

  loadCampaigns() {
	this.campaignService.getCampaigns().subscribe(res => {
	  this.campaigns = res;
	  this.cdr.detectChanges();
	});
  }

  initForms() {
	  this.detailForm = this.fb.group({
		campaignStartId: [null, Validators.required],
		campaignEndId: [null, Validators.required],
		zone: [null/*, Validators.required*/] // Solicitado por Mariana Mele.
	  });
  }

  export(flag) {
	const controls = this.detailForm.controls;
	if (this.detailForm.invalid) {
	  Object.keys(controls).forEach(controlName => {
		controls[controlName].markAsTouched();
	  });
	  return;
	}

	const delinquencyQuery = DelinquencyQuery.empty();
	delinquencyQuery.campaignIdFrom = this.detailForm.controls["campaignStartId"].value;
	delinquencyQuery.campaignIdTo = this.detailForm.controls["campaignEndId"].value;
	delinquencyQuery.zoneId = this.detailForm.controls["zone"].value;

	const filename = flag ? "campaign" : "reseller";
	const asyncJob = flag ?
		this.resellerStamentService.delinquencyReportByCampaign(delinquencyQuery) :
		this.resellerStamentService.delinquencyReportByReseller(delinquencyQuery);
	asyncJob.subscribe({
		next: asyncJobId => {
			this.logger.debug("AsyncJobId for report:", asyncJobId);
			const throttler = new TruncatedExponentialBackoff();
			this.asyncJobService
				.tryToRetrieveBlob(asyncJobId, {
					consume: report => {
						this.logger.debug(`Downloaded file of ${report.size} bytes.`);
						saveAs(report, `[${new Date().toISOString()}]-delinquency-by-${filename}.xlsx`);
					},
					delayBetweenRetries: _ => throttler.nextInMilliseconds(),
					mimeType: () => MimeType.MICROSOFT_EXCEL_XLSX,
					error: (error: Error) => {
						this.logger.error(error);
					}
				});
		},
		error: (error: Error) => {
			this.logger.error(error);
		}
	});
  }

  onNoClick(): void {
	this.dialogRef.close(false);
  }

  isControlHasError(controlName: string, validationType: string): boolean {
	const control = this.detailForm.controls[controlName];
	if (!control) {
	  return false;
	}

	return control.hasError(validationType) && (control.dirty || control.touched);
  }
}
